// Fixed public Murph narration. Generate once; visitors only fetch these assets.
// Keep each recording and bubble text in sync. Never substitute a browser voice.
const VOICE_PATH = '/mascot/voice/murph-v2';
export const INTRO_LINE = "Hey, I'm Splash! Ready for a quick look around? Let's dive in!";
export const INTRO_AUDIO = `${VOICE_PATH}/intro.mp3?v=2`;
export const OUTRO_LINE = "That's the tour! SplashPad is for swim instructors and everyone building a swim school. Ready to dive in? Click below to start your free trial.";
export const OUTRO_AUDIO = `${VOICE_PATH}/outro.mp3?v=2`;

export const TOUR_STOPS = [
    {
        anchorId: 'mascot-anchor-hero',
        align: 'right',
        line: "SplashPad brings your whole swim business together, whether you're a swim instructor or a swim school.",
        audio: `${VOICE_PATH}/hero.mp3?v=2`,
        cta: 'Meet your sidekick',
    },
    {
        anchorId: 'meet-si',
        align: 'left',
        line: "Just tell me what you need! I'll prepare the changes, show you a preview, and handle it when you confirm.",
        audio: `${VOICE_PATH}/si-agent.mp3?v=2`,
        cta: 'Less admin, more coaching',
    },
    {
        anchorId: 'problem',
        align: 'left',
        line: 'Less juggling, more teaching. Keep your schedules, payments, and waivers together with one login.',
        audio: `${VOICE_PATH}/problem.mp3?v=2`,
        cta: 'See who uses SplashPad',
    },
    {
        anchorId: 'mascot-anchor-gallery',
        align: 'right',
        line: 'Take a look at the schools already making a splash. Your own branded page could be next!',
        audio: `${VOICE_PATH}/gallery.mp3?v=2`,
        cta: 'Get discovered',
    },
    {
        anchorId: 'find-coach',
        align: 'left',
        line: "Parents can find you on the map and sign up in minutes. Let's get you discovered!",
        audio: `${VOICE_PATH}/map.mp3?v=2`,
        cta: 'Grow your swim business',
    },
    {
        anchorId: 'grows-with-you',
        align: 'right',
        line: 'Going solo or growing a team? Bring your staff, pools, and payroll along. SplashPad grows with you.',
        audio: `${VOICE_PATH}/grows.mp3?v=2`,
        cta: 'Everything in one place',
    },
    {
        anchorId: 'features',
        align: 'left',
        line: 'Bookings, payments, waivers, and your website. Everything you need to keep your swim business moving.',
        audio: `${VOICE_PATH}/features.mp3?v=2`,
        cta: 'See what you could save',
    },
    {
        anchorId: 'savings',
        align: 'right',
        line: 'Curious what you could save? Try the calculator and compare your costs in a few clicks.',
        audio: `${VOICE_PATH}/savings.mp3?v=2`,
        cta: 'Find your plan',
    },
    {
        anchorId: 'pricing',
        align: 'left',
        line: 'Try SplashPad free for thirty days. Pro includes a personal onboarding call to help you dive right in.',
        audio: `${VOICE_PATH}/pricing.mp3?v=2`,
        cta: 'Start my trial',
    },
];
